// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.brewcontrol_run_state_enum */
var BrewcontrolRunStateEnum;
(function (BrewcontrolRunStateEnum) {
    BrewcontrolRunStateEnum["created"] = "created";
    BrewcontrolRunStateEnum["running"] = "running";
    BrewcontrolRunStateEnum["stopped"] = "stopped";
    BrewcontrolRunStateEnum["removed"] = "removed";
    BrewcontrolRunStateEnum["lost"] = "lost";
})(BrewcontrolRunStateEnum || (BrewcontrolRunStateEnum = {}));
;
export default BrewcontrolRunStateEnum;
/** Zod schema for brewcontrol_run_state_enum */
export const brewcontrolRunStateEnum = z.nativeEnum(BrewcontrolRunStateEnum);
//# sourceMappingURL=BrewcontrolRunStateEnum.js.map